export const MAP_STATUS_PURCHASE_REQUESTS = {
    'bost_Open' : {name: 'Pendiente', color: 'red darken-2', status: 1, value: false, filter_value: 'pending'},
    'bost_Close': {name: 'Cerrado', color: 'green darken-2', status: 2, value: true, filter_value: 'closed'},
    'bost_ReviewAbastecimiento': {name: 'Pendiente de revisión por Abastecimiento', color: 'orange darken-1', status: 3, value: 3, filter_value: 'pending_revision_abastecimiento'}
}

// Filtro de estatus de plataforma (query param `plataforma_status` del backend)
export const PLATAFORMA_STATUS_FILTER_OPTIONS = [
    {value: 'Solicitado', name: 'Solicitado'},
    {value: 'Parcialmente Comprado', name: 'Parcialmente Comprado'},
    {value: 'Comprado', name: 'Comprado'}
]

export const GET_MAPPED_STATUS_PURCHASE_REQUEST = (status) => {
  return MAP_STATUS_PURCHASE_REQUESTS[status]
    ? MAP_STATUS_PURCHASE_REQUESTS[status]
    : { name: status, color: "grey darken-3" };
}

export const GET_COLOR_FROM_STATUS = (status) => {
  if(!status){
      return 'grey darken-3'
  }
  switch (true) {
    case status.includes("Parcialmente"):
      return "orange darken-1";
    case status.includes("Comprado"):
      return "purple darken-1";
      case status.includes("Transferido"):
        return "purple darken-1";  
    case status.includes("Recibido"):
      return "green darken-1";
    case status.includes("Cancelado"):
      return "red darken-1";
    default:
      return "primary";
  }
}